import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';

export const TextBlockRect = styled.rect<{ height?: number; }>`
    width: 100%;
    height: ${p => p.height ? rem(p.height) : '100%'};
`;
